var React = require('react');

function Flechas (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Grupo_193","data-name":"Grupo 193","transform":"translate(-266.259 -639.991)"},[React.createElement("path",{"id":"Trazado_278","data-name":"Trazado 278","d":"M6992.661,1230.393l4.321,5.615-4.321,5.615","transform":"translate(-6725 -589)","fill":"none","stroke":"#c7cce8","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Trazado_279","data-name":"Trazado 279","d":"M6992.661,1230.393l4.321,5.615-4.321,5.615","transform":"translate(-6719.72 -589)","fill":"none","stroke":"#c7cce8","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Flechas.defaultProps = {"width":"12.004","height":"14.036","viewBox":"0 0 12.004 14.036"};

module.exports = Flechas;

Flechas.default = Flechas;
